<div class="ecb-dashboard">

  <!-- DASHBOARD HEADER -->
  <div class="ecb-dashboard-header">
    <div class="ecb-dashboard-header-left">
      <h1>Admin Dashboard</h1>
      <p>High level overview of training activity, courses and enquiries.</p>
    </div>

    <div class="ecb-dashboard-header-right">
      <button type="button" class="ecb-dashboard-refresh" (click)="loadPageData()">
        <i class="fa fa-refresh"></i>
        Refresh
      </button>

      <a routerLink="/admin/courses" class="ecb-dashboard-add-button">
        <i class="fa fa-plus"></i>
        Add Course
      </a>
    </div>
  </div>

  <!-- LOADING -->
  <div class="ecb-dashboard-feedback" *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin"></i>
    Loading dashboard...
  </div>

  <!-- ERROR -->
  <div class="ecb-dashboard-feedback ecb-dashboard-error" *ngIf="!isLoading && errorMessage">
    <i class="fa fa-exclamation-circle"></i>
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!isLoading && dashboard">

    <!-- OVERVIEW + COURSE CATALOG IN SAME ROW -->
    <div class="row g-2">

      <!-- OVERVIEW -->
      <div class="col-12 col-xl-6">
        <section class="ecb-dashboard-section">
          <div class="ecb-dashboard-section-heading">
            <h2>Overview</h2>
            <p>Key statistics across the training platform</p>
          </div>

          <div class="ecb-dashboard-summary-grid">
            <div class="ecb-dashboard-summary-card" *ngFor="let item of overviewStats"
              [ngClass]="'ecb-dashboard-tone-' + item.tone">

              <div class="ecb-dashboard-summary-card-left">
                <div class="ecb-dashboard-summary-icon">
                  <i class="fa" [ngClass]="item.icon"></i>
                </div>

                <div class="ecb-dashboard-summary-text">
                  <h3>{{ item.label }}</h3>
                  <p>{{ item.description }}</p>
                </div>
              </div>

              <div class="ecb-dashboard-summary-card-right">
                <span>Total</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- COURSE CATALOG -->
      <div class="col-12 col-xl-6">
        <section class="ecb-dashboard-section">
          <div class="ecb-dashboard-section-heading">
            <h2>Course Catalog</h2>
            <p>Active training courses and assessments</p>
          </div>

          <div class="ecb-dashboard-summary-grid">
            <div class="ecb-dashboard-summary-card" *ngFor="let item of courseStats"
              [ngClass]="'ecb-dashboard-tone-' + item.tone">

              <div class="ecb-dashboard-summary-card-left">
                <div class="ecb-dashboard-summary-icon">
                  <i class="fa" [ngClass]="item.icon"></i>
                </div>

                <div class="ecb-dashboard-summary-text">
                  <h3>{{ item.label }}</h3>
                  <p>
                    {{
                    item.lastAddedDate
                    ? (item.lastAddedDate | date:'dd MMM yyyy')
                    : 'No date available'
                    }}
                  </p>
                </div>
              </div>

              <div class="ecb-dashboard-summary-card-right">
                <span>Total</span>
                <strong>{{ item.count }}</strong>
              </div>
            </div>
          </div>
        </section>
      </div>

    </div>

    <!-- ENQUIRIES -->
    <div class="row g-2 mt-1">
      <div class="col-12">
        <section class="ecb-dashboard-section">
          <div class="ecb-dashboard-section-heading">
            <h2>Enquiries</h2>
            <p>Track total, approved and registered enquiries</p>
          </div>

          <div class="row g-2">
            <div class="col-12 col-lg-4" *ngFor="let item of enquiryStats">

              <div class="ecb-dashboard-enquiry-card" [ngClass]="'ecb-dashboard-tone-' + item.tone">

                <!-- TOP -->
                <div class="ecb-dashboard-enquiry-top">
                  <div class="ecb-dashboard-enquiry-left">
                    <div class="ecb-dashboard-summary-icon">
                      <i class="fa" [ngClass]="item.icon"></i>
                    </div>

                    <h3>{{ item.label }}</h3>
                  </div>

                  <div class="ecb-dashboard-enquiry-total-box">
                    <span>Total</span>
                    <strong>{{ item.total }}</strong>
                  </div>
                </div>

                <!-- APPROVED -->
                <div class="ecb-dashboard-progress-block">
                  <div class="ecb-dashboard-progress-label">
                    <span>Approved</span>
                    <strong>{{ item.approved }}</strong>
                  </div>

                  <div class="ecb-dashboard-progress-bar">
                    <div class="ecb-dashboard-progress-fill approved"
                      [style.width.%]="getPercentage(item.approved, item.total)">
                    </div>
                  </div>

                  <small>
                    {{ getPercentage(item.approved, item.total) }}% of total enquiries
                  </small>
                </div>

                <!-- REGISTERED -->
                <div class="ecb-dashboard-progress-block">
                  <div class="ecb-dashboard-progress-label">
                    <span>Registered</span>
                    <strong>{{ item.registered }}</strong>
                  </div>

                  <div class="ecb-dashboard-progress-bar">
                    <div class="ecb-dashboard-progress-fill registered"
                      [style.width.%]="getPercentage(item.registered, item.total)">
                    </div>
                  </div>

                  <small>
                    {{ getPercentage(item.registered, item.total) }}% of total enquiries
                  </small>
                </div>

              </div>

            </div>
          </div>
        </section>


      </div>
    </div>

  </ng-container>
<br>
<hr>
  <ng-container *ngIf="!isLoading && dashboard">


    <div class="row  ">

      <!-- OVERVIEW -->
      <div class="col-12 col-xl-12">
        <app-admin-public-home-content></app-admin-public-home-content>
      </div>
    </div>
  </ng-container>
</div>